// 英语
export const English = {
  language_code: "en",
  get_btn: "Redeem now",
  unregistered_tip: "Unregistered users will directly create an account.",
  phone_number: "Phone number",
  ver_code: "Verification code",
  get_ver_code: "Get code",
  retrieve_ver_code: "Resend ({SECONDS})",
  age_tip: "I am an adult with full civil capacity and agree to ",
  and: " and ",
  PRIVICY_POLICY: '"Privacy Policy"',
  MEMBER_AGGREMENT: '"Membership Terms"',
  agree_push:
    "I agree to receive Haidilao notifications via my registered mobile number or email.",
  CN: "China",
  US: "United States",
  CA: "Canada",
  GB: "United Kingdom",
  MY: "Malaysia",
  AU: "Australia",
  ID: "Indonesia",
  SG: "Singapore",
  TH: "Thailand",
  JP: "Japan",
  KR: "Korea",
  VN: "Vietnam",
  HK: "Hong Kong Region",
  MO: "Macao Region",
  HKM: "Cambodia",
  TW: "Taiwan Region",
  PH: "Philippines",
  UAE: "UAE",
  suc_send: "Sent successfully",
  suc_get: "Success",
  fail_ver_code: "Incorrect code",
  time_end: "Event has ended",
  not_get_repeat: "Cannot redeem again!",
  not_get_eligible: "Cannot redeem, not eligible for the event.",
  not_get_late: "You were a step too late, the event has ended.",
  get_coupon: "Claim coupon",
  phone_err: "Invalid phone number. Please enter a valid phone number.",
  page_title: "Claim exclusive Haidilao coupon",
  send_code_error: "Error sending verification code",
  network_error: "Your network is currently unstable, please try again later.",
  member_status_abnormal: "Membership account error, unable to claim",
  send_frequently:
    "Too many verification codes have been sent. Enter the last code you received or try again later.",
  activity_boom: "Too many people claiming. Please try again later.",
  email: "Email",
  email_error_tip: "Invalid email address. Please enter a valid email.",
  suc_get_dialog_text:
    "Open the Haidilao Membership APP now to view your redeemed coupons!",
  btn_sure: "OK",
  btn_cancel: "Cancel",
  suc_dialog_text:
    "Open the Haidilao APP or link your membership with LINE to view your claimed coupons!",
  btn_return: "Back",
  btn_download: "Download",
};
